import type { PaginaDataModel } from '@/interfaces/model';
import type { PaginaData } from '@/interfaces/strapi';

export const pageMapper = (item: PaginaDataModel): PaginaData => ({
	id: item.id,
	title: item.title,
	slug: item.slug,
	body: item.body,
});
